import styled, { css } from "styled-components";
import { Select } from "antd";
import { theme } from "../../styles/theme";

export const CustomSelect = styled(Select)`
  width: 100%;
  font-size: ${theme.fonts.size.default};

  &&& {
    .ant-select {
      &-selection-search-input {
        height: 100% !important;
        line-height: ${(props) => props.height || "50px"} !important;

        &:hover, &:focus {
          border: none !important;
          outline: none !important;
          box-shadow: none !important;
        }
      }

      &-selector {
        height: auto !important;
        min-height: ${(props) => props.height || "50px"};
        align-items: center;
        border-color: ${theme.colors.light4};
        border-radius: ${(props) => props.radius || "12px"};
        padding-left: ${(props) => props.paddingx}px;
        padding-right: ${(props) => props.paddingx}px;

        // Adding style when search
        .ant-select-selection-search {
          left: 0;
          right: 0;
          padding-left: ${(props) => props.paddingx}px !important;
          
          &-input {
            padding-left: 0 !important;
            margin-left: 0 !important;
            border: none !important;
            outline: none !important;
            box-shadow: none !important;

            &:hover, &:focus {
              border: none !important;
              outline: none !important;
              box-shadow: none !important;
            }
          }
        }
      }

      &-selection-search-input,
      &-selection-placeholder {
        height: auto !important;
        min-height: ${(props) => props.height || "50px"};

        &:hover {
          border: 1px solid ${theme.colors.light4} !important;
          box-shadow: initial;
          border-radius: ${(props) => props.radius || "12px"};
        }
      }

      &-selection-overflow {
        height: auto !important;
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
        gap: 2px;

        &-item {
          height: 35px !important;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0;
          padding: 0 2px;
          border-radius: 6px;
        }
      }

      &-selector,
      &-selection-search-input,
      &-selection-placeholder {
        line-height: ${(props) => props.height || "50px"};
      }
      &-selection-placeholder {
        color: ${theme.colors.grey1};
      }
      &-selection-item {
        height: ${(props) => props.height || "35px"};
        padding-top: 0;
        color: ${theme.colors.grey};
        text-transform: capitalize;
        font-family: ${theme.fonts.family};
        display: flex;
        align-items: center;
        justify-content: center;

        &-content {
          height: 35px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
      
    &.ant-select-multiple {
      .ant-select-selection-item {
        padding-right: 24px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
      }

      .ant-select-selection-item-remove {
        position: absolute;
        right: 4px;
        top: 55%;
        transform: translateY(-50%);
        display: inline-flex !important;
        align-items: center;
        justify-content: center;
        color: ${theme.colors.grey};
        font-size: 12px;
        opacity: 1;
        visibility: visible !important;
        height: 100%;
        &:hover {
          color: ${theme.colors.error};
        }
      }
    }
    &.ant-select {
      // When focus
      &-focused:not(.ant-select-disabled) {
        &.ant-select-show-search {
          img {
            display: none;
          }
        }
        .ant-select-selector {
          outline: 0;
          border: 1px solid ${theme.colors.light4} !important;
          box-shadow: initial;
        }
      }
      // When open
      &-open {
        &:not(.ant-select-show-search) {
          .ant-select-arrow {
            transform: rotate(-180deg);
          }
        }
      }
      // When disabled
      &-disabled {
        .ant-select-selection-placeholder {
          color: ${theme.colors.grey1};
        }
      }
      // On Search
      &-show-search {
        .ant-select-selection-item {
          display: block;
          align-items: center;
        }
      }

      .ant-select-arrow {
        display: flex !important;
        align-items: center;
        justify-content: center;

        img {
          display: block !important;
          width: 16px;
          height: 16px;
        }
      }
    }
  }
`;
